"use strict";
/* eslint-disable @typescript-eslint/ban-ts-comment */
/** @jsx jsx */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPatientOverviewTableData = exports.patientOverviewColumns = exports.RowStatus = exports.RowType = void 0;
const summithill_models_1 = require("@clearsummit/summithill-models");
const core_1 = require("@emotion/core");
const moment_1 = __importDefault(require("moment"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const react_table_1 = require("react-table");
const constants_1 = require("@/constants");
const __1 = require("..");
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
var RowType;
(function (RowType) {
    RowType["section"] = "section";
    RowType["content"] = "content";
})(RowType = exports.RowType || (exports.RowType = {}));
var RowStatus;
(function (RowStatus) {
    RowStatus["complete"] = "Complete";
    RowStatus["incomplete"] = "Incomplete";
})(RowStatus = exports.RowStatus || (exports.RowStatus = {}));
const getRowType = (rowValue) => {
    if (rowValue instanceof summithill_models_1.Section) {
        return RowType.section;
    }
    return RowType.content;
};
const getStatus = (rowValue) => rowValue.state === 'COMPLETE' ? RowStatus.complete : RowStatus.incomplete;
exports.patientOverviewColumns = [
    {
        accessor: 'checkbox',
        // @ts-ignore
        Cell: ({ row, onCheck, pending, isSectionAvailable, isContentAvailable, }) => {
            const { original } = row;
            return (core_1.jsx("div", { className: styles_scss_1.default.checkboxCell },
                core_1.jsx(__1.Checkbox
                // @ts-ignore
                , { 
                    // @ts-ignore
                    checked: original.state === 'COMPLETE', ariaLabel: "Select Row", 
                    // @ts-ignore
                    name: `row-${original.rowType}-${original.id}`, 
                    // @ts-ignore
                    id: `row-${original.rowType}-${original.id}`, 
                    // @ts-ignore
                    disabled: 
                    // @ts-ignore
                    pending || original.rowType === RowType.section
                        ? // @ts-ignore
                            !isSectionAvailable(original.id)
                        : // @ts-ignore
                            !isContentAvailable(original.id), onChange: () => {
                        onCheck(
                        // @ts-ignore
                        original.rowType, 
                        // @ts-ignore
                        original.content_type, 
                        // @ts-ignore
                        original.id, 
                        // @ts-ignore
                        original.state === 'COMPLETE');
                    } })));
        },
    },
    {
        accessor: 'status',
        Cell: ({ value }) => (core_1.jsx(__1.Badge, { className: styles_scss_1.default.badge, label: value, variant: value === 'Complete' ? 'primary' : 'secondary' })),
    },
    { accessor: 'name' },
    { accessor: 'dateCompleted' },
    {
        accessor: 'totalCompleted',
        Cell: ({ row, value, accountId }) => {
            const { original } = row;
            const therapyNoteRoute = () => constants_1.Routes.TherapyNoteEdit
                .replace(':accountId', accountId)
                // @ts-ignore
                .replace(':sessionId', original.id)
                // @ts-ignore
                .replace(':therapyNoteId', original.therapy_note || "");
            const processQuestionRoute = () => constants_1.Routes.PatientProcessQuestion
                .replace(':patientId', accountId)
                // @ts-ignore
                .replace(':contentId', original.id);
            // @ts-ignore
            if (original.rowType === RowType.content && original.therapy_note !== undefined) {
                return (core_1.jsx(__1.Link, { to: therapyNoteRoute(), className: styles_scss_1.default.addNotesLink },
                    core_1.jsx(__1.Button, { title: "Add Notes", ariaLabel: "add notes", variant: "transparent", imgUrls: { default: constants_1.Images.plus, selected: constants_1.Images.plus } })));
            }
            // @ts-ignore
            if (original.rowType === RowType.content && original.content_type === 'PROCESS_QUESTION'
                // @ts-ignore
                && original.state === 'COMPLETE') {
                return (core_1.jsx(__1.Link, { to: processQuestionRoute(), className: styles_scss_1.default.addNotesLink },
                    core_1.jsx(__1.Button, { title: "See Answers", ariaLabel: "see answers", variant: "transparent", imgUrls: { default: constants_1.Images.eye, selected: constants_1.Images.eye } })));
            }
            return core_1.jsx("div", { className: styles_scss_1.default.totalCompletedLabel }, value);
        },
    },
];
const getPatientOverviewTableData = (sections) => {
    const data = [];
    sections.forEach((section) => {
        const totalCompleted = `${section.contents.filter((c) => c.state === 'COMPLETE').length}/${section.contents.length} Completed`;
        data.push(Object.assign(Object.assign({}, section), { id: section.id, status: getStatus(section), totalCompleted: section instanceof summithill_models_1.Section ? totalCompleted : '', rowType: getRowType(section) }));
        section.contents.forEach((content) => {
            data.push(Object.assign(Object.assign({}, content), { id: content.id, status: getStatus(content), dateCompleted: content.completed_at
                    ? moment_1.default(content.completed_at).format('MM/DD/YYYY hh:mm a')
                    : '--', name: section instanceof summithill_models_1.Section ? content.name : section.name, rowType: getRowType(content) }));
        });
    });
    return data;
};
exports.getPatientOverviewTableData = getPatientOverviewTableData;
const PatientOverviewTable = ({ data, columns, match, onCheck, pending, isSectionAvailable, isContentAvailable, }) => {
    const tableColumns = react_1.useMemo(() => columns, [columns]);
    const tableData = react_1.useMemo(() => data, [data]);
    // @ts-ignore
    const { getTableProps, getTableBodyProps, rows, prepareRow } = react_table_1.useTable({
        // @ts-ignore
        columns: tableColumns,
        data: tableData,
    }, react_table_1.useRowSelect);
    const { accountId } = match.params;
    return (core_1.jsx("div", { className: styles_scss_1.default.patientOverviewTableWrapper },
        core_1.jsx("table", Object.assign({}, getTableProps()),
            core_1.jsx("tbody", Object.assign({}, getTableBodyProps()), rows.map(row => {
                const { original } = row;
                const { rowType } = original;
                prepareRow(row);
                return (core_1.jsx("tr", Object.assign({}, row.getRowProps(), { css: styles_1.default.patientOverviewTableRow(rowType) }), row.cells.map(cell => (core_1.jsx("td", Object.assign({}, cell.getCellProps()), cell.render('Cell', {
                    accountId,
                    onCheck,
                    pending,
                    isSectionAvailable,
                    isContentAvailable,
                }))))));
            })))));
};
exports.default = react_router_1.withRouter(PatientOverviewTable);
